import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import ModalHeader from '../../Setup/Shared/ModalHeader';
import DatePicker from '../../General/DatePicker';
import { Modal } from "react-bootstrap";
import SuperSearchList from '../SuperSearch/SuperSearchList';
import { useEffect, useRef, useState } from 'react';
import isNull from '../../../utils/NullChecking';
import { enumUtil } from '../../../utils/Enum';
import { ServerRequestProtected, ServerRequestProtectedOCR } from '../../../utils/ServerDataRequest';
import NotificationHandler from '../../../utils/NotificationHandler';
import Loader from '../Loader/Loader';
import FormValidator from '../../../utils/FormValidator';
import handleDecimalCheck from '../../../utils/handleDecimalCheck';
import { FindSecondChild } from '../../../utils/FindMenuOption';
import AmountFormatter from '../../../utils/AmountFormatter';
import PatAdvancePaymentConfirmation from '../../Patient/PatientDetails/PatientPayment/PatAdvancePaymentConfirmation';
import ModalFooter from '../../Setup/Shared/ModalFooter';
import useHandleOpenNewBrowserTab from '../NewTabBrowser/useHandleOpenNewBrowserTab';
import isAmountNull from '../../../utils/AmountNullChecker';
import { useSelector } from 'react-redux';


const PatientPayments = (props) => {
    let IsEditAllowed = FindSecondChild('Billing', 'Payments', 'Patient Payment')?.IsAdd
    let { isOpenPatientPayments, OnClosePtPayment, PatientID, type, ID, AdvancePayment, PrintStatementsLogsID, StatementNumber } = { ...props }
    const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();
    let InvoiceMode = useSelector(state => state.SettingsReducer.InvoiceMode) || 'Detail View';
    const [gender, setGender] = useState('')
    const [name, setName] = useState('')
    let Cash_Modal = {
        Reference: '',
        Comments: '',
        PaymentMethod: '',
    }
    let Check_Modal = {
        Reference: '',
        Check: '',
        CheckAmount: '',
        Comments: '',
        PaymentMethod: '',
    }
    let Other_Modal = {
        Reference: '',
        OtherPaymentMethod: '',
        Comments: '',
        PaymentMethod: '',
    }
    let Credit_Modal = {
        Reference: '',
        CreditCard: '',
        Last4Digit: '',
        Comments: '',
        PaymentMethod: '',
    }
    let Pateint_Modal = {
        PatientName: '',
        InsuranceName: '',
        MobileNumber: '',
        Email: '',
        PatientBalance: '',
        CopayDue: '',
        LastPaymentDate: '',
        PatientBalance: '',
        ProfilePicture: '',
    }
    let valModal = {}
    let ValidationModal = {
        DateCollectedVal: '',
        CollectedAmountVal: '',
    }
    const [validation, setValidation] = useState({ ValidationModal })
    const PatientPaymentValidation = async () => {
        let ValidationModal = {
            DateCollectedVal: FormValidator(
                DateCollected,
                enumUtil.enumValidationType.Required,
                'Date ',
            ),
            CollectedAmountVal: FormValidator(
                CollectedAmount,
                enumUtil.enumValidationType.Required,
                'Amount ',
            )
        }
        await setValidation(ValidationModal)
        valModal = ValidationModal

    }
    const PatientPaymentValidationCheck = async () => {
        let ValidationModal = {
            CheckVal: FormValidator(
                mainCheck.Check,
                enumUtil.enumValidationType.Required,
                'Check # ',
            ), DateCollectedVal: FormValidator(
                DateCollected,
                enumUtil.enumValidationType.Required,
                'Date ',
            ),
            CollectedAmountVal: FormValidator(
                CollectedAmount,
                enumUtil.enumValidationType.Required,
                'Amount ',
            )
        }
        await setValidation(ValidationModal)
        valModal = ValidationModal
    }
    const PatientPaymentValidationCredit = async () => {
        let ValidationModal = {
            // CreditVal: FormValidator(
            //     mainCredit.CreditCard,
            //     enumUtil.enumValidationType.Required,
            //     'CreditCard ',
            // ), 
            DateCollectedVal: FormValidator(
                DateCollected,
                enumUtil.enumValidationType.Required,
                'Date ',
            ),
            CollectedAmountVal: FormValidator(
                CollectedAmount,
                enumUtil.enumValidationType.Required,
                'Amount ',
            )
        }
        await setValidation(ValidationModal)
        valModal = ValidationModal

    }
    let paymentGateWayTokenizerURL = useSelector(state => state.SettingsReducer?.paymentGateWayTokenizerURL);
    let GatewayFeesOnPatient = useSelector(state => state.SettingsReducer?.GatewayFeesOnPatient);

    const [isAutoAllocated, setIsAutoAllocated] = useState(true)
    const API_URL = enumUtil.controller.Claim
    const API_URL_Payment = enumUtil.controller.PatientPayment
    let isLive = process.env.REACT_APP_ISLIVE
    let BASE_URL = process.env.REACT_APP_FURL
    const [patientID, setPatientID] = useState('')
    const [mainCash, setmainCash] = useState(Cash_Modal)
    const [saveUpdatedCash, setsaveUpdatedCash] = useState({})
    const [mainCheck, setmainCheck] = useState(Check_Modal)
    const [saveUpdatedCheck, setsaveUpdatedCheck] = useState({})
    const [mainOther, setmainOther] = useState(Other_Modal)
    const [saveUpdatedOther, setsaveUpdatedOther] = useState({})
    const [mainCredit, setmainCredit] = useState(Credit_Modal)
    const [saveUpdatedCredit, setsaveUpdatedCredit] = useState({})
    const [mainPtCredit, setmainPtCredit] = useState(Check_Modal)
    const [saveUpdatedPtCredit, setsaveUpdatedPtCredit] = useState({})
    const [mainPateintModal, setmainPatientModal] = useState(Pateint_Modal)
    const [paymentMethod, setPaymentMethod] = useState('Cash')
    const [mainPtPaymentSave, setmainPtPaymentSave] = useState({ ...mainCash, PaymentMethod: 'Cash' })
    const [PatientName, setPatientName] = useState('')
    const [patientBody, setPatientBody] = useState({ "TableName": "", "SearchParam": '' })
    const [isPateintAvailable, setisPateintAvailable] = useState(false)
    const [DueClaims, setDueClaims] = useState([])
    const [DueClaimsSave, setDueClaimsSave] = useState([])
    const [is, setIs] = useState(false);
    const [DateCollected, setDateCollected] = useState(null)
    const [CollectedAmount, setCollectedAmount] = useState('')
    const [UnAppliedAAmount, setUnAppliedAAmount] = useState('')
    const [presistedUnAppliedAAmount, setpresistedUnAppliedAAmount] = useState('')
    const [PaymentsID, setPaymentsID] = useState('')
    const [TotalAmount, setTotalAmount] = useState(0)
    const Pateint = () => {
        return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '14px', fontWeight: '600', margin: 'auto' }}> Patient Payment</p>;
    };
    const [isLoading, setIsLoading] = useState(false)
    const [image, setImage] = useState("")
    const [isReadOnly, setIsReadOnly] = useState(false)
    const PatientDetailsForPatientPayment = (patientID) => {
        if (type !== 'PaymentSearch') {
            setIsLoading(true);
            ServerRequestProtected(API_URL_Payment + "/PatientDetailsForPatientPayment", 'post', {
                "TableName": enumUtil.enumAPITableName.COLLECTPATIENTPAYMENTS,
                "ID": patientID + "",
            })
                .then((response) => {
                    setIsLoading(false)
                    setmainPatientModal(response)
                    setGender(response?.Gender)
                    setName(response?.PatientName)
                    setisPateintAvailable(true)
                }).catch((error) => {
                    setIsLoading(false)
                    setisPateintAvailable(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    const PatientClaimsForPatientPayment = (patientID) => {
        if (type !== 'PaymentSearch') {
            ServerRequestProtected(API_URL_Payment + "/PatientClaimsForPatientPayment", 'post', {
                "TableName": enumUtil.enumAPITableName.COLLECTPATIENTPAYMENTS,
                "SEARCHCRITERIA": {
                    "PatientID": patientID + "",
                    "ClaimID": ID + "",
                    "PrintStatementsLogsID": PrintStatementsLogsID ? PrintStatementsLogsID : null
                }
            })
                .then((response) => {
                    if (AdvancePayment > 0) {
                        setisOpenPatAdvPayment(true)
                    }
                    setDueClaims(response)
                    let data = [...response]
                    let totalAmt = 0
                    data.map((item) => {
                        totalAmt = totalAmt + item.PatientBalance
                    })
                    setTotalAmount(totalAmt)
                }).catch((error) => {
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                    setDueClaims([])
                })
        }
    }
    const PatientPaymentDetails = (patientID, PatientPaymentsID) => {
        if (type === 'PaymentSearch') {
            setIsReadOnly(true)
            setIsLoading(true);
            ServerRequestProtected(API_URL_Payment + "/GetPatientPaymentData", 'post', {
                "TableName": enumUtil.enumAPITableName.COLLECTPATIENTPAYMENTS,
                "SEARCHCRITERIA": {
                    "PatientID": patientID,
                    "PatientPaymentsID": PatientPaymentsID
                }
            })
                .then((response) => {
                    setIsLoading(false)
                    setGender(response?.Patient?.Gender)
                    setName(response?.Patient?.PatientName)
                    setPaymentMethod(response.Patient.PaymentMethod)
                    setCollectedAmount(response.Patient.CollectedAmount + "")
                    setDateCollected(response.Patient.CollectedDate)
                    setUnAppliedAAmount(response.Patient.UnAppliedAmount - "")
                    setpresistedUnAppliedAAmount(response.Patient.UnAppliedAmount - "")
                    setmainPatientModal(response.Patient)
                    let data = [...response.PatientClaims]
                    data.map((item) => {
                        item['IsReadOnly'] = true
                    })
                    setDueClaims(data)
                    setisPateintAvailable(true)
                }).catch((error) => {
                    setIsLoading(false)
                    setisPateintAvailable(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    useEffect(() => {
        if (!isNull(PatientID)) {
            setPatientID(PatientID);
            PatientDetailsForPatientPayment(PatientID);
            PatientClaimsForPatientPayment(PatientID);
            PatientPaymentDetails(PatientID, ID)
        }
    }, [PatientID])
    const handleChangePatientPayment = (e, type) => {
        let { name, value } = e.target
        if (type === 'cash') {
            let modal = { ...mainCash }
            let saveModal = { ...saveUpdatedCash }
            modal[name] = value
            setmainCash(modal)
            for (var property in Cash_Modal) {
                if (name === property) {
                    saveModal[name] = value
                }
            }
            setsaveUpdatedCash(saveModal)
        } else if (type === 'check') {
            let modal = { ...mainCheck }
            let saveModal = { ...saveUpdatedCheck }
            modal[name] = value
            setmainCheck(modal)
            for (var property in Check_Modal) {
                if (name === property) {
                    saveModal[name] = value
                }
            }
            setsaveUpdatedCheck(saveModal)
        } else if (type === 'credit') {
            let modal = { ...mainCredit }
            let saveModal = { ...saveUpdatedCredit }
            modal[name] = value
            setmainCredit(modal)
            for (var property in Credit_Modal) {
                if (name === property) {
                    saveModal[name] = value
                }
            }
            setsaveUpdatedCredit(saveModal)
        } else if (type === 'other') {
            let modal = { ...mainOther }
            let saveModal = { ...saveUpdatedOther }
            modal[name] = value
            setmainOther(modal)
            for (var property in Other_Modal) {
                if (name === property) {
                    saveModal[name] = value
                }
            }
            setsaveUpdatedOther(saveModal)
        } else if (type === 'ptcredit') {
            let modal = { ...mainPtCredit }
            let saveModal = { ...saveUpdatedPtCredit }
            modal[name] = value
            setmainPtCredit(modal)
            for (var property in Cash_Modal) {
                if (name === property) {
                    saveModal[name] = value
                }
            }
            setsaveUpdatedPtCredit(saveModal)
        }
    }
    const CollectedAmountValidation = () => {

        let dueClaimsData = [...DueClaims]
        const allValuesEmpty = dueClaimsData.every(item => item.AllocateAmount === "");
        let totalAllocatedAmount = 0
        dueClaimsData.map((item, index) => {
            let alocateamount = parseFloat(item.AllocateAmount);
            totalAllocatedAmount = totalAllocatedAmount + alocateamount
        })
        let colletedAmountint = parseFloat(CollectedAmount);
        if (totalAllocatedAmount > colletedAmountint) {
            return 'Total allocated amount cannot be greater than collected amount'
        } else if (allValuesEmpty) {
            return 'Enter Allocated Amount'
        } else {
            return false
        }
    }
    const [isCreditPaymentSucess, setisCreditPaymentSucess] = useState(false)
    const [creditPaymentRecipt, setCreditPaymentRecipt] = useState('')
    const API_URL_InovicePayment = enumUtil.controller.InovicePayment
    const API_URL_PatientPay = enumUtil.controller.PatientPay
    const stripeSessionRef = useRef(null);
    const handleSavePtPayment = async () => {
        if (paymentMethod === 'Credit') {
            let AmountValidation = CollectedAmountValidation()
            await PatientPaymentValidationCredit()
            let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)

            if (DueClaims.length === 0) {
                NotificationHandler('No record found for due claims', enumUtil.enumtoaster.error)
            } else if (AmountValidation !== false) {
                NotificationHandler(AmountValidation, enumUtil.enumtoaster.error)
                return
            } else if (validation) {
                NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
                return
            } else {
                // if (InvoiceMode === 'Detail View') {
                DetailedViewPayment()
                // } else if (InvoiceMode === 'Summary View') {
                //     SummaryViewPayment()
                // }
            }
        } else {
            handleSavePtPaymentActual()
        }
    }
    const SummaryViewPayment = () => {
        setIsLoading(true);

        // ✅ Open popup immediately (user action context)
        const popup = window.open(
            "",
            "StripePayment",
            "width=500,height=700"
        );

        if (!popup) {
            setIsLoading(false);
            alert(
                "Popup blocked!\n\n" +
                "Please allow popups for this site and try again.\n\n" +
                "Chrome: Click address bar → Popups → Allow"
            );
            return;
        }

        // Optional loading message
        popup.document.write("<p style='font-family:sans-serif'>Loading payment...</p>");

        ServerRequestProtectedOCR(
            API_URL_InovicePayment + "/checkout-session",
            "post",
            {
                amount: CollectedAmount,
                reason: saveUpdatedCredit.Comments,
                PatientID: PatientID + ""
            }
        )
            .then((response) => {
                const appealLink = response?.checkoutUrl;

                if (!appealLink) {
                    popup.close();
                    NotificationHandler("Payment URL not found!", enumUtil.enumtoaster.error);
                    return;
                }

                // ✅ Redirect popup instead of opening new one
                popup.location.href = appealLink;

                listenForStripeResult(popup);
            })
            .catch((error) => {
                popup.close();
                NotificationHandler(error.response?.data, enumUtil.enumtoaster.error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    const DetailedViewPayment = () => {
        let ProcedureItems = [...DueClaims]
        ProcedureItems = ProcedureItems
            .filter(item => !isNull(item.AllocateAmount))
            .map((item) => {
                return {
                    unitAmount: !isAmountNull(item.AllocateAmount) ? (item.AllocateAmount + "") : '0',
                    Units: item.Units + "",
                    name: item.name
                }
            });
        setIsLoading(true)
        // ServerRequestProtectedOCR(API_URL_InovicePayment + "/checkout-session-list", 'post', {
        ServerRequestProtectedOCR(API_URL_PatientPay + "/ProcessPayment", 'post', {
            // amount: CollectedAmount,
            // reason: saveUpdatedCredit.Comments,
            PatientID: patientID + '',
            ProcedureItems: ProcedureItems,
            PrintStatementsLogsID: PrintStatementsLogsID ? PrintStatementsLogsID : '',
            StatementNumber: StatementNumber ? StatementNumber : ''

        }).then((response) => {
            let appealLink = response?.checkoutUrl;
            if (appealLink) {
                if (response?.paymentGateWay === 'Stripe') {
                    const width = Math.floor(window.screen.width * 0.83);
                    const height = Math.floor(window.screen.height * 0.76);
                    const left = (window.screenLeft || window.screenX) + (window.innerWidth - width);
                    const top = (window.screenTop || window.screenY) + (window.innerHeight - height);
                    // `width=${width},height=${height},left=${left},top=${top}`
                    const popup = window.open(
                        appealLink,
                        'StripePayment',
                        "width=500,height=700",
                    );
                    if (!popup) {
                        alert("Popup blocked. Please allow popups.");
                        setIsLoading(false)
                        return;
                    }
                    listenForStripeResult(popup);
                    setIsLoading(false)
                } else {
                    let data = { ...response, paymentGateWayTokenizerURL: paymentGateWayTokenizerURL }
                    localStorage.setItem('PatientPaymentDetails', JSON.stringify(data));
                    // 'https://portal.theeasyedi.com/#/PatientPayment',
                    // 'http://localhost:3000/#/PatientPayment',
                    const popup = window.open(
                        `${BASE_URL}#/PatientPayment`,
                        // 'https://portal.theeasyedi.com/#/PatientPayment',
                        // 'http://localhost:3000/#/PatientPayment',
                        'InternalPayment',
                        "width=800,height=700"
                    );
                    if (!popup) {
                        alert("Popup blocked. Please allow popups.");
                        return;
                    }
                    listenForInternalPaymentResult(popup);
                    setIsLoading(false)
                    // localStorage.setItem('PatientPaymentDetails', JSON.stringify(response));
                    // window.open('http://localhost:3000/#/PatientPayment', '_blank');
                }
            }
            else {
                NotificationHandler('Page Not Found!', enumUtil.enumtoaster.error)
            }
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data.error, enumUtil.enumtoaster.error)
        })
    }
    const listenForStripeResult = (popup) => {
        const messageHandler = (event) => {
            console.log("MESSAGE RECEIVED FROM POPUP:", event);

            // ✅ ACCEPT ONLY SAME-ORIGIN MESSAGES
            // if (event.origin !== window.location.origin) return;

            // ✅ IGNORE REACT DEVTOOLS / EXTENSIONS
            if (!event.data || event.data.source === "react-devtools-bridge") return;

            let { sessionID, PaymentIntentId, status, receiptUrl } = event.data || {};

            console.log(
                sessionID,
                PaymentIntentId,
                status,
                receiptUrl,
                event.data,
                "Stripe"
            );

            // ✅ ONLY PROCESS REAL STRIPE DATA
            if (!sessionID) return;

            setCreditPaymentRecipt(receiptUrl);

            stripeSessionRef.current = {
                sessionID,
                PaymentIntentId,
                status,
                receiptUrl
            };

            console.log("Stripe Session ID:", stripeSessionRef.current);
            console.log("Payment Intent ID:", PaymentIntentId);

            window.removeEventListener("message", messageHandler);
            popup?.close(); // close automatically after save
        };

        // ✅ Attach listener
        window.addEventListener("message", messageHandler);

        // 🔒 KEEPING YOUR MANUAL CLOSE + SAVE LOGIC EXACTLY
        const timer = setInterval(() => {
            if (popup.closed) {
                clearInterval(timer);
                window.removeEventListener("message", messageHandler);
                console.log("Stripe popup closed manually", stripeSessionRef);

                if (stripeSessionRef.current?.status === "Success") {
                    handleSavePtPaymentActual(
                        stripeSessionRef.current.sessionID,
                        stripeSessionRef.current.PaymentIntentId
                    );
                } else {
                    NotificationHandler(
                        "Payment Failed, please try again",
                        enumUtil.enumtoaster.error
                    );
                    setisCreditPaymentSucess(false);
                }
            }
        }, 300);
    };
    // const listenForInternalPaymentResult = (popup) => {
    //     const messageHandler = (event) => {

    //         if (event.origin !== window.location.origin) return;

    //         if (!event.data || event.data.source === "react-devtools-bridge") return;

    //         const { paymentId, status } = event.data || {};

    //         if (!paymentId) return;

    //         window.removeEventListener("message", messageHandler);

    //         popup?.close();

    //         if (status === "Success") {
    //             handleSavePtPaymentActual(paymentId);
    //         } else {
    //             NotificationHandler(
    //                 "Payment Failed, please try again",
    //                 enumUtil.enumtoaster.error
    //             );
    //         }
    //     };

    //     window.addEventListener("message", messageHandler);
    // };
    const paymentListeners = useRef({
        active: false,
        processedPaymentIds: new Set()
    });
    const listenForInternalPaymentResult = (popup) => {
        // If already listening, don't add another listener
        // debugger
        if (paymentListeners.current.active) {
            console.log('Payment listener already active, ignoring duplicate');
            return;
        }
        paymentListeners.current.active = true;
        const messageHandler = (event) => {
            if (event.origin !== window.location.origin) return;
            if (!event.data || event.data.source === "react-devtools-bridge") return;
            const { paymentId, status, printStatementsLogsID, error } = event.data || {};
            // console.log( error);
            if (!isNull(error)) {
                NotificationHandler(error, enumUtil.enumtoaster.error);
                return
            }
            if (!paymentId) return;
            // Check if this payment was already processed
            if (paymentListeners.current.processedPaymentIds.has(paymentId)) {
                return;
            }
            // Mark as processed
            paymentListeners.current.processedPaymentIds.add(paymentId);
            // Cleanup
            window.removeEventListener("message", messageHandler);
            paymentListeners.current.active = false;

            // if (window.paymentPopupInterval) {
            //     clearInterval(window.paymentPopupInterval);
            //     window.paymentPopupInterval = null;
            // }
            popup?.close();
            if (status === "Success") {
                handleSavePtPaymentActual(paymentId, '', printStatementsLogsID);
                localStorage.removeItem('PatientPaymentDetails');
            } else {
                NotificationHandler(error, enumUtil.enumtoaster.error);
                localStorage.removeItem('PatientPaymentDetails');
            }
        };
        window.addEventListener("message", messageHandler);
        // window.paymentPopupInterval = setInterval(() => {
        //     if (popup.closed) {
        //         clearInterval(window.paymentPopupInterval);
        //         window.paymentPopupInterval = null;
        //         window.removeEventListener("message", messageHandler);
        //         paymentListeners.current.active = false;
        //     }
        // }, 300);
    };
    const isProcessingPayment = useRef(false);
    const handleSavePtPaymentActual = async (SessionID, PaymentIntentId, printStatementsLogsID) => {
        if (isProcessingPayment.current) {
            console.log('Payment already being processed, ignoring duplicate call');
            return;
        }
        isProcessingPayment.current = true;
        let AmountValidation = CollectedAmountValidation()
        await PatientPaymentValidation()
        if (paymentMethod === 'Credit') {
            await PatientPaymentValidationCredit()
        } else if (paymentMethod === 'Check') {
            await PatientPaymentValidationCheck()
        }
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (DueClaims.length === 0) {
            isProcessingPayment.current = false;
            NotificationHandler('No record found for due claims', enumUtil.enumtoaster.error)
            return
        } else if (AmountValidation !== false) {
            isProcessingPayment.current = false;
            NotificationHandler(AmountValidation, enumUtil.enumtoaster.error)
            return
        } else if (validation) {
            isProcessingPayment.current = false;
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            let SaveModal
            if (paymentMethod === 'Cash') {
                SaveModal = { ...saveUpdatedCash, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, PaymentMethod: paymentMethod }
            } else if (paymentMethod === 'Check') {
                SaveModal = { ...saveUpdatedCheck, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, PaymentMethod: paymentMethod }
            } else if (paymentMethod === 'Credit') {
                SaveModal = {
                    ...saveUpdatedCredit, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, PaymentMethod: paymentMethod,
                    SessionID: SessionID ? SessionID : '', PaymentIntentId: PaymentIntentId, printStatementsLogsID: printStatementsLogsID ? printStatementsLogsID : ''
                }
            } else if (paymentMethod === 'Other') {
                SaveModal = { ...saveUpdatedOther, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, PaymentMethod: paymentMethod }
            } else if (paymentMethod === 'Patient Credit') {
                SaveModal = { ...saveUpdatedPtCredit, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, PaymentMethod: paymentMethod }
            } else {
                SaveModal = { ...saveUpdatedCash, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, PaymentMethod: 'Cash' }
            }
            // if (type === 'Claim') {
            SaveModal['ClaimID'] = type === 'Claim' ? ID + "" : null
            SaveModal['PaymentType'] = 'PatientPayment'
            // } else if (type === 'Payment') {
            SaveModal['PatientID'] = patientID + ""
            // }
            let updatedDueClaims = DueClaimsSave
                .filter(item => !isNull(item.AllocateAmount))
                .map(item => {
                    const updatedItem = { ...item };
                    for (const key in updatedItem) {
                        if (updatedItem[key] != null) {
                            updatedItem[key] = updatedItem[key] + "";
                        }
                    }
                    return updatedItem;
                });
            let saveModal = {
                TableName: enumUtil.enumAPITableName.COLLECTPATIENTPAYMENTS,
                ID: type === 'PaymentSearch' ? ID + "" : "0",
                data: SaveModal, 'PatientPayment': updatedDueClaims,
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL_Payment + "/CollectPatientPayments", 'post', saveModal).then((response) => {
                if (!isNull(props.LoadClaimData)) {
                    props.LoadClaimData()
                }
                if (!isNull(response.id)) {
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    localStorage.removeItem('PatientPaymentDetails');
                    setPaymentsID(response.id)
                    setIsLoading(false)
                    // if (paymentMethod === 'Credit') {
                    //     setisCreditPaymentSucess(true)
                    // } else {

                    OnClosePtPayment('PtPayment')
                    // }
                    isProcessingPayment.current = false;
                }
            }).catch((error) => {
                setPaymentsID('')
                setIsLoading(false)
                isProcessingPayment.current = false;
                localStorage.removeItem('PatientPaymentDetails');
                if (error.response.data !== 'Payment with this Invoice already exists') {
                    console.log(error.response.data)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                }
            })
        }
    }
    const ViewPatientCriditRecipt = () => {
        if (!isNull(creditPaymentRecipt)) {
            window.open(creditPaymentRecipt, "_blank", "noopener,noreferrer");
        } else if (!isNull(PaymentsID)) {

            // for local dev `http://localhost:3000/#/ViewPaidReceipt/${PaymentsID}`,
            // for dev   `https://portal.theeasyedi.com/#/ViewPaidReceipt/${PaymentsID}`,
            // `https://portal.theeasyedi.com/#/ViewPaidReceipt/${PaymentsID}`,
            window.open(
                `${BASE_URL}#/ViewPaidReceipt/${PaymentsID}`,
                // `https://portal.theeasyedi.com/#/ViewPaidReceipt/${PaymentsID}`,
                //  `http://localhost:3000/#/ViewPaidReceipt/${PaymentsID}`,
                "_blank",
                "noopener,noreferrer"
            );
        }
    }
    const OnClosePayment = () => {
        setisCreditPaymentSucess(false)
        setCreditPaymentRecipt('')
        OnClosePtPayment()
        isProcessingPayment.current = false
    }
    const handleChangeLink = (type) => {
        if (type === 'Patient Credit') {
            setCollectedAmount(AdvancePayment + "")
            setUnAppliedAAmount(AdvancePayment - "")
        }
        setPaymentMethod(type)
    }
    const handleSelectedData = (selectedData, name, type) => {
        if (name === 'PatientID' && !isNull(selectedData)) {
            if (selectedData.value != -1) {
                setPatientID(selectedData.value + "");
                setPatientName(selectedData.display);
                PatientDetailsForPatientPayment(selectedData.value + "");
                PatientClaimsForPatientPayment(selectedData.value + "");
                setGender(selectedData.Gender || '')
                setName(selectedData.display || '')

            } else {
                setPatientID("")
                setPatientName("")
            }
        } else {
            setPatientID("")
            setPatientName("")
        }
    }
    const getInitials = (name) => {
        const nameArray = name.split(' ');
        if (nameArray.length >= 2) {
            return nameArray[1][0] + nameArray[0][0];
        } else if (nameArray.length === 1) {
            return nameArray[0][0];
        }
        return '';
    };
    const userInitials = getInitials(name)
    const handlePateintChange = (e) => {
        setIs(false);
        let { name, value } = e.target;
        setPatientName(value);
        setPatientBody({ "TableName": enumUtil.enumAPITableName.COLLECTPATIENTPAYMENTS, "SearchParam": value })
    }
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        setDateCollected(FormatedDate)
    }
    const handleDueClaimChange = (e, index) => {
        let { name, value } = e.target;
        if (!isNull(CollectedAmount)) {
            let DueClaimItem = [...DueClaims];
            DueClaimItem[index][name] = value
            DueClaimItem[index]['ID'] = '0'
            setDueClaimsSave(DueClaimItem)
        } else {
            NotificationHandler('Add collected amount to allocate amount', enumUtil.enumtoaster.error)
        }

        // calculateCollectedAmount()
    }
    const calculateCollectedAmount = () => {
        let TotalCollectedAmount = 0
        let DueClaimItem1 = [...DueClaims];
        DueClaimItem1.map((item, index) => {
            if (!isNull(item.AllocateAmount)) {
                TotalCollectedAmount += item.AllocateAmount - ""
            }
        })
        let unAppliedint = CollectedAmount - ""
        TotalCollectedAmount = unAppliedint - TotalCollectedAmount
        setUnAppliedAAmount(TotalCollectedAmount + "")
        console.log(TotalCollectedAmount);
    }
    const addAllocatedAmttoDueData = (UnAppliedAAmt) => {
        DueClaims.map((item, index) => {
            if (UnAppliedAAmt > item.PatientBalance) {
                item.AllocateAmount = parseFloat(item.PatientBalance.toFixed(2));
                UnAppliedAAmt = UnAppliedAAmt - item.PatientBalance
            } else if (UnAppliedAAmt > 0) {
                item.AllocateAmount = parseFloat(UnAppliedAAmt.toFixed(2));
                UnAppliedAAmt = 0
            } else {
                // Error = true
            }
        })
        setUnAppliedAAmount(UnAppliedAAmt)
        setDueClaimsSave(DueClaims)
    }
    const handleAmountChange = (e) => {
        let value = e.target.value
        setCollectedAmount(value)
        let UnAppliedAAmt = value - ""
        if (!isNull(value) && isAutoAllocated) {
            addAllocatedAmttoDueData(UnAppliedAAmt)
        } else {
            setUnAppliedAAmount(value)
        }
    }
    const handleAutoAllocate = (e) => {
        let value = e.target.checked
        setIsAutoAllocated(value)
        let Error = false

        // debugger
        if (value === true) {
            if (!isNull(CollectedAmount)) {
                // Convert UnAppliedAAmount to number safely
                let UnAppliedAAmt = parseFloat(UnAppliedAAmount) || 0;

                DueClaims.forEach((item, index) => {
                    // Convert PatientBalance to number safely
                    if (type === 'PaymentSearch' && item.IsReadOnly === true) {
                        return;
                    }
                    const patientBalance = parseFloat(item.PatientBalance) || 0;

                    if (UnAppliedAAmt > patientBalance) {
                        item.AllocateAmount = Math.round(patientBalance * 100) / 100;
                        UnAppliedAAmt = Math.round((UnAppliedAAmt - patientBalance) * 100) / 100;
                    } else if (UnAppliedAAmt > 0) {
                        item.AllocateAmount = Math.round(UnAppliedAAmt * 100) / 100;
                        UnAppliedAAmt = 0;
                    } else {
                        Error = true;
                    }
                })

                setUnAppliedAAmount(UnAppliedAAmt)
                setDueClaimsSave(DueClaims)
                // if (Error === true) {
                //     NotificationHandler('Insufficient Un-Applied Amount', enumUtil.enumtoaster.error)
                // }
            }
        } else {
            // debugger
            let dueClaimsData = [...DueClaims]
            dueClaimsData.forEach((item, index) => {
                if (type === 'PaymentSearch' && item.IsReadOnly === true) {
                    return;
                }
                item.AllocateAmount = ''
            })

            if (!isNull(CollectedAmount)) {
                // Convert CollectedAmount to number safely
                if (type === 'PaymentSearch') {
                    setUnAppliedAAmount(presistedUnAppliedAAmount);
                } else {
                    const collectedAmountNum = parseFloat(CollectedAmount) || 0;
                    setUnAppliedAAmount(collectedAmountNum);
                }

            } else {
                if (type === 'PaymentSearch') {
                    setUnAppliedAAmount(presistedUnAppliedAAmount);
                } else {
                    const collAmt = parseFloat(CollectedAmount) || 0;
                    setUnAppliedAAmount(Math.round(collAmt * 100) / 100)
                }
            }
            setDueClaims(dueClaimsData)
            setDueClaimsSave(dueClaimsData)
        }
    }
    const handleOpenClaim = (item) => {
        let data = {
            name: 'Claims',
            data: {
                id: item.ClaimID,
                name: item.PatientFirstName,
                VisitType: item.ClaimType
            }
        };
        handleOpenNewBrowserTab(data)
    }
    const handleSearchList = () => {
        setisPateintAvailable(false);
        setPatientName('');
        setPatientID('');
    }
    const handleImageChange = (e) => {
        const Type = e.target.files[0].type.substring(0, 5);
        if (Type === 'image') {
            let file = e.target.files[0]
            let reader = new FileReader();
            reader.onloadend = () => {
                let value = reader.result.toString();
                setmainPatientModal({ ...mainPateintModal, ProfilePicture: value })
                // set({ ...UserSaveUpdateModal, Picture: value })
            }
            reader.readAsDataURL(file);
        }

    }
    const [isOpenPatAdvPayment, setisOpenPatAdvPayment] = useState(false)
    const closePatAdvPayentConf = () => {
        setisOpenPatAdvPayment(false)
    }
    const onProceddPatAdvPayentConf = () => {
        setisOpenPatAdvPayment(false)
        handleChangeLink('Patient Credit')
    }
    let AdvancePopup
    if (isOpenPatAdvPayment) {
        AdvancePopup = <PatAdvancePaymentConfirmation isOpenPatAdvPayment={isOpenPatAdvPayment} closePatAdvPayentConf={closePatAdvPayentConf} onProceddPatAdvPayentConf={onProceddPatAdvPayentConf} AdvancePayment={AdvancePayment} />
    }
    const handleShowUpaidData = () => {
        setIsReadOnly(false)
        setIsLoading(true);
        ServerRequestProtected(API_URL_Payment + "/PatientClaimsForPatientPayment", 'post', {
            "TableName": enumUtil.enumAPITableName.COLLECTPATIENTPAYMENTS,
            "SEARCHCRITERIA": {
                "PatientID": PatientID,
            }
        })
            .then((response) => {
                setIsLoading(false)
                // setCollectedAmount(response.Patient.CollectedAmount + "")
                // setDateCollected(response.Patient.CollectedDate)
                // setUnAppliedAAmount(response.Patient.UnAppliedAmount - "")
                // setmainPatientModal(response.Patient)
                let preDueClaims = [...DueClaims]
                preDueClaims.map((item) => {
                    item['IsReadOnly'] = true
                })
                let data = [...response]
                data.map((item) => {
                    item['IsReadOnly'] = false
                })
                data = [...preDueClaims, ...data]
                setDueClaims(data)
                // setisPateintAvailable(true)
            }).catch((error) => {
                setIsLoading(false)
                // setisPateintAvailable(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
    }
    const [divStyle, setDivStyle] = useState({ top: 0, left: 0, position: 'fixed', });
    const handleMouseEnter = (event) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setDivStyle({
            top: `calc(${rect.bottom}px + 8px)`,
            left: `calc(${rect.left}px - 15px)`,
            position: 'fixed',
        });
    };
    const statusClasses = {
        Posted: "Paid",
        New: "New",
        "Partially Posted": "Partialpaid",
        Processed: "pill-success",
        Reviewed: "In-Review",
        External: "information-Required",
        Pending: "pill-danger",
    };
    const handleApplyAll = () => {
        addAllocatedAmttoDueData(TotalAmount)
        setCollectedAmount(TotalAmount + "")
        setIsAutoAllocated(true)
    }
    return (
        <>
            {AdvancePopup}
            <Modal show={isOpenPatientPayments} onHide={isOpenPatientPayments} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 add_patient_payment add_block_appointment">
                {isLoading ? <Loader /> : null}
                <Modal.Body>
                    <ModalHeader HeaderName={Pateint} DeletePopup={""} isClosed={OnClosePayment} key={111} Name={'PatientPayments'} />
                    <div className="px-2 d-flex flex-column gap-2">

                        {isPateintAvailable === true ?
                            <div className="d-flex justify-content-between ar-copay-img">
                                {type !== 'Claim' && type !== 'PaymentSearch' ?
                                    <div className='search'>
                                        <i className='bi bi-search' onClick={() => handleSearchList()} ></i>
                                    </div>
                                    : null}

                                <div className="d-flex gap-2  py-2">
                                    <div className="img-container s-50 circle ">
                                        {mainPateintModal.ProfilePicture ?
                                            <img src={mainPateintModal.ProfilePicture} alt="" />
                                            :
                                            <p
                                                className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white ${gender === 'M'
                                                    ? 'za-male'
                                                    : gender === 'F'
                                                        ? 'za-female'
                                                        : 'za-others'
                                                    }`}
                                            >
                                                {userInitials}
                                            </p>
                                        }

                                        {/* <i className="icon-camera-outline"></i>
                                        <input type="file" name="ProfilePicture" id="ProfilePicture" accept=".jpg, .jpeg, .png,"
                                            autoComplete="off"
                                            onChange={handleImageChange}
                                        /> */}
                                    </div>
                                    <div>
                                        <p className="heading">{mainPateintModal.PatientName}</p>
                                        <p className="text ar-dark-color sm_text">
                                            {mainPateintModal.IsSelfPayPatient ?
                                                <span className='hk-schedulerModal__main'>
                                                    <div className="hk-details__bottom">
                                                        <p className="text fs-12 text-nowrap d-flex gap-1 align-items-center  ar-pencil col-md-4"><em>Self Pay</em></p>
                                                    </div>
                                                </span>
                                                : mainPateintModal.InsuranceName ?
                                                    <><i className='icon-umbrella-solid'></i> {mainPateintModal.InsuranceName}</> :
                                                    <><span className='ar-umbrella'>
                                                        <i className='icon-umbrella-solid text-danger opacity-25'></i> <span className='text-danger text'>INSURANCE NOT FOUND</span>
                                                    </span>
                                                    </>

                                            }
                                        </p>

                                        <div className="d-flex align-items-center gap-2 ">
                                            <p className="text ar-dark-color sm_text">

                                                {mainPateintModal.MobileNumber ? <><i className="bi bi-telephone-fill me-1"></i> <span>{mainPateintModal.MobileNumber}</span></> : <><i className="bi bi-telephone-fill text-danger opacity-25 me-1"></i> <span className='text-danger text'>Phone Not Provided </span></>}</p>
                                            <span className="line"></span>
                                            <p className="text ar-dark-color sm_text">

                                                {mainPateintModal.Email ? <><i className="bi bi-envelope-fill me-1"></i> <span>{mainPateintModal.Email}</span></> : <><i className="bi bi-envelope-fill text-danger opacity-25 me-1"></i> <span className='text-danger text'>Email not Provided</span> </>}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-2 me-1">
                                    <p className="text ar-dark-color sm_text">Last Pat. Payment Date: <span className="heading xsm_heading ar-dark-color">{mainPateintModal.LastPaymentDate ? mainPateintModal.LastPaymentDate : 'N/A'}</span></p>
                                    <p className="text ar-dark-color d-flex sm_text justify-content-end gap-1 align-items-baseline">Patient Balance:<span className="heading xsm_heading ar-dark-color">{!isNull(mainPateintModal.PatientBalance) ? '$' + mainPateintModal.PatientBalance : 'N/A'}</span></p>
                                    {/* <p className="text ar-dark-color d-flex  sm_text justify-content-end gap-25">Copay Due <span className="heading ar-dark-color ms-1 xsm_heading">{!isNull(mainPateintModal.CopayDue) ? '$' + mainPateintModal.CopayDue : 'N/A'}</span></p> */}
                                    <div className="d-flex justify-content-end">
                                        <p className={`pill w-max-content  ${statusClasses[mainPateintModal?.PostingStatus]}`} >{mainPateintModal?.PostingStatus}</p>
                                    </div>
                                </div>
                            </div>
                            :
                            <>
                                <div className='form-group input mt-3 flex-row align-items-center mb-2'>
                                    <SuperSearchList
                                        type='server'
                                        id='PatientID'
                                        name='PatientID'
                                        method="post"
                                        searchValue={PatientName}
                                        ApiLink={API_URL + "/PatientInstantSearch"}
                                        postBody={patientBody}
                                        onChange={handlePateintChange}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        // disabled={true}
                                        PatientPayment={true}
                                        placeholder={false}
                                        icon={true}
                                        autocomplete={false}
                                    />
                                </div>
                                <div className='d-flex justify-content-between ar-copay-img '>
                                    <div className="d-flex gap-4 py-2">
                                        <div className="img-container s-50 circle border-2  ar-bgc-img">
                                        </div>
                                        <div>
                                            <p className="ar-bgc-content m-0" style={{ width: '50%' }}></p>
                                            <p className="ar-bgc-content w-30 m-0 mt-2" style={{ width: '55%' }}></p>
                                            <p className="ar-bgc-content w-30 m-0 mt-2"></p>
                                        </div>
                                    </div>
                                    <div className='py-2 me-2 '>
                                        <p className="ar-bgc-content-1 w-30 m-0 "></p>
                                        <p className="ar-bgc-content-1 mt-2 m-0 ms-auto" style={{ width: '70%' }}></p>
                                        <p className="ar-bgc-content-1 w-30 m-0 mt-2 ms-auto" style={{ width: '70%' }}></p>
                                    </div>
                                </div>
                            </>
                        }
                        <div className="row align-items-end">
                            <div className="col-md-7">
                                <div className="d-flex align-items-baseline gap-12">
                                    <div className="w-75">
                                        <label className="text ar-light-color">Collected Date <span className='req'>*</span></label>
                                        <div className={validation.DateCollectedVal ? 'input error' : 'error'}>
                                            <DatePicker
                                                // label='Date Collected'
                                                value={DateCollected}
                                                handleCalendarChangefunc={date => handleCalendarChange(date)}
                                                inputError={!isNull(validation.DateCollectedVal) ? true : false}
                                                isReadOnly={type === 'PaymentSearch' ? true : false}
                                            />
                                            {validation.DateCollectedVal}
                                        </div>
                                    </div>
                                    <div className='w-100'>
                                        <div className={validation.CollectedAmountVal ? 'input error' : 'error'}>
                                            <label htmlFor="" className="d-flex justify-content-between align-items-center">
                                                <p className="text ar-light-color">Collected Amount</p>
                                                <span className='text validate-color fs-11 cursor-pointer' onClick={handleApplyAll}> Apply All (<AmountFormatter amount={TotalAmount} />)</span>
                                                {/* <span className='req'>*</span> */}
                                            </label>
                                            <input
                                                type="text"
                                                className={validation.CollectedAmountVal ? 'form-control fc-xs  form-control-amount error' : 'form-control fc-xs  form-control-amount'}
                                                name="CollectedAmount"
                                                id="CollectedAmount"
                                                value={CollectedAmount}
                                                autoComplete='off'
                                                onChange={handleAmountChange}
                                                onKeyPress={handleDecimalCheck}
                                                readOnly={paymentMethod === 'Patient Credit' ? true : type === 'PaymentSearch' ? true : false}
                                            />
                                            {validation.CollectedAmountVal}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-5">
                                <div className="d-flex flex-column gap-1">
                                    <div className="d-flex align-items-center gap-1">
                                        <p className='text ar-light-color'>Posted Amount:</p>
                                        <p className='text ar-light-color font-m'>{!isAmountNull(mainPateintModal.PostedAmount) ? '$' + mainPateintModal.PostedAmount : 'N/A'}</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-1">
                                        <p className='text ar-light-color'>Un Posted Amount:</p>
                                        <p className='text ar-light-color font-m'>{UnAppliedAAmount !== '' ? '$' + UnAppliedAAmount : 'N/A'}</p>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="col-md-3">
                                <label htmlFor="" className="text ar-light-color">Posted Amount</label>
                                <p className="text ar-light-color"> {!isAmountNull(mainPateintModal.PostedAmount) ? '$' + mainPateintModal.PostedAmount : 'N/A'}</p>
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="" className="text ar-light-color">Un-Applied Amount</label>
                                <p className="text ar-light-color"> {UnAppliedAAmount !== '' ? '$' + UnAppliedAAmount : 'N/A'}</p>
                            </div> */}
                        </div>

                        <div className="row">
                            <div className="col-12 patient_payment_tabs">
                                <span className="text ar-light-color">Payment Method</span>
                                <Tab.Container activeKey={paymentMethod}>
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <Nav variant="tabs" className="d-flex border-0 gx-0 mt-1">
                                            <Nav.Item className="ar-copay-link" onClick={() => handleChangeLink('Cash')}>
                                                <Nav.Link eventKey="Cash" className="text">Cash</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="ar-copay-link" onClick={() => handleChangeLink('Check')}>
                                                <Nav.Link eventKey="Check" className="text">Check</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="ar-copay-link" onClick={() => handleChangeLink('Credit')}>
                                                <Nav.Link eventKey="Credit" className="text">Credit</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="ar-copay-link" onClick={() => handleChangeLink('Other')}>
                                                <Nav.Link eventKey="Other" className="text">Other</Nav.Link>
                                            </Nav.Item>
                                            {AdvancePayment > 0 ?
                                                <Nav.Item className="ar-copay-link" onClick={() => handleChangeLink('Patient Credit')}>
                                                    <Nav.Link eventKey="Patient Credit" className="text d-flex align-items-center gap-1 isolation-unset">
                                                        Patient Credit
                                                        <span className='font-sb orange-drk'>(${AdvancePayment})</span>
                                                        <span className='za-denied-status position-relative d-flex pat-cradit'>
                                                            <i className='icon-alert'></i>
                                                            <p className="xsm_text text-light tool_tip text-start">Patient Credit is the available balance from advance payments </p>
                                                        </span>
                                                    </Nav.Link>
                                                </Nav.Item>
                                                : null}
                                        </Nav>
                                        {type === 'PaymentSearch' && mainPateintModal?.PostingStatus !== 'Posted' && !isNull(UnAppliedAAmount) ?
                                            <button className="btn btn-validate px-2 rounded" onClick={handleShowUpaidData} >Show Unpaid Charges</button>
                                            : null}
                                    </div>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="Cash">
                                            <div className="row">
                                                <div className="col-4 d-flex flex-column">
                                                    <label htmlFor="" className="text ar-light-color">Reference #</label>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount "
                                                        name="Reference"
                                                        id="Reference"
                                                        autoComplete='off'
                                                        value={mainCash.Reference}
                                                        onChange={(e) => handleChangePatientPayment(e, 'cash')}
                                                    />
                                                </div>
                                                <div className="col-8 d-flex flex-column">
                                                    <label htmlFor="" className="text ar-light-color">Comments</label>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount "
                                                        name="Comments"
                                                        id="Comments"
                                                        autoComplete='off'
                                                        value={mainCash.Comments}
                                                        onChange={(e) => handleChangePatientPayment(e, 'cash')}
                                                    />
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="Check">
                                            <div className="row row-gap-8">
                                                <div className="col-3 d-flex flex-column">
                                                    <label htmlFor="" className="text ar-light-color">Reference #</label>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount"
                                                        name="Reference"
                                                        id="Reference"
                                                        autoComplete='off'
                                                        value={mainCheck.Reference}
                                                        onChange={(e) => handleChangePatientPayment(e, 'check')}
                                                    />
                                                </div>
                                                <div className="col-3 d-flex flex-column">
                                                    <label htmlFor="" className="text ar-light-color">Check # <span className='req'>*</span></label>
                                                    <input
                                                        type="text"
                                                        className={validation.CheckVal ? 'form-control fc-xs rounded form-control-amount error' : 'form-control fc-xs rounded form-control-amount'}
                                                        name="Check"
                                                        id="Check"
                                                        autoComplete='off'
                                                        value={mainCheck.Check}
                                                        onChange={(e) => handleChangePatientPayment(e, 'check')}
                                                    />
                                                    {validation.CheckVal}
                                                </div>
                                                <div className="col-3 d-flex flex-column">
                                                    <label htmlFor="" className="text ar-light-color">Check Amount</label>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount"
                                                        name="CheckAmount"
                                                        id="CheckAmount"
                                                        autoComplete='off'
                                                        value={mainCheck.CheckAmount}
                                                        onChange={(e) => handleChangePatientPayment(e, 'check')}
                                                    />
                                                </div>
                                                <div className="col-9 d-flex flex-column">
                                                    <label htmlFor="" className="text ar-light-color">Comments</label>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount"
                                                        name="Comments"
                                                        id="Comments"
                                                        autoComplete='off'
                                                        value={mainCheck.Comments}
                                                        onChange={(e) => handleChangePatientPayment(e, 'check')}
                                                    />
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="Credit">
                                            <div className="row">
                                                <div className="col-3 d-flex flex-column">
                                                    <label htmlFor="" className="text ar-light-color">Reference #</label>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount"
                                                        name="Reference"
                                                        id="Reference"
                                                        autoComplete='off'
                                                        value={mainCredit.Reference}
                                                        onChange={(e) => handleChangePatientPayment(e, 'credit')}
                                                    />
                                                </div>
                                                {/* <div className="col-3">
                                                    <label for="creditCard" className="text ar-light-color" >Credit Card <span className='req'>*</span></label>
                                                    <input
                                                        type="text"
                                                        className={validation.CreditVal ? 'form-control fc-xs rounded form-control-amount error' : 'form-control fc-xs rounded form-control-amount'}
                                                        name="CreditCard"
                                                        id="CreditCard"
                                                        autoComplete='off'
                                                        value={mainCredit.CreditCard}
                                                        onChange={(e) => handleChangePatientPayment(e, 'credit')}
                                                    />
                                                    {validation.CreditVal}
                                                </div> */}
                                                {/* <div className="col-4">
                                                    <label htmlFor="Last4Digit" className="text ar-light-color">Last 4-Digits of Card</label>
                                                    <div className="d-flex align-items-center">
                                                        <label className="col-7 text ar-light-color"> XXXX-XXXX-XXXX-</label>
                                                        <input
                                                            type="text"
                                                            className="form-control fc-xs rounded form-control-amount"
                                                            name="Last4Digit"
                                                            id="Last4Digit"
                                                            autoComplete='off'
                                                            value={mainCredit.Last4Digit}
                                                            onChange={(e) => handleChangePatientPayment(e, 'credit')}
                                                        />
                                                    </div>
                                                </div> */}
                                                <div className="col-9 d-flex flex-column">
                                                    <label htmlFor="" className="text ar-light-color">Comments</label>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount"
                                                        name="Comments"
                                                        id="Comments"
                                                        autoComplete='off'
                                                        value={mainCredit.Comments}
                                                        onChange={(e) => handleChangePatientPayment(e, 'credit')}
                                                    />
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="Other">
                                            <div className="row align-items-baseline ">
                                                <div className="col-3 d-flex flex-column">
                                                    <label htmlFor="" className="text ar-light-color">Reference #</label>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount"
                                                        name="Reference"
                                                        id="Reference"
                                                        autoComplete='off'
                                                        value={mainOther.Reference}
                                                        onChange={(e) => handleChangePatientPayment(e, 'other')}
                                                    />
                                                </div>
                                                <div className="col-3 d-flex flex-column">
                                                    <label for="creditCard" className="text ar-light-color" >Other Payment Method</label>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount"
                                                        name="OtherPaymentMethod"
                                                        id="OtherPaymentMethod"
                                                        autoComplete='off'
                                                        value={mainOther.OtherPaymentMethod}
                                                        onChange={(e) => handleChangePatientPayment(e, 'other')}
                                                    />
                                                </div>
                                                <div className="col-6 d-flex flex-column">
                                                    <label htmlFor="" className="text ar-light-color">Comments</label>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount"
                                                        name="Comments"
                                                        id="Comments"
                                                        autoComplete='off'
                                                        value={mainOther.Comments}
                                                        onChange={(e) => handleChangePatientPayment(e, 'other')}
                                                    />
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="Patient Credit">
                                            <div className="row">
                                                <div className="col-4 d-flex flex-column">
                                                    <label htmlFor="" className="text ar-light-color">Reference #</label>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount"
                                                        name="Reference"
                                                        id="Reference"
                                                        autoComplete='off'
                                                        value={mainPtCredit.Reference}
                                                        onChange={(e) => handleChangePatientPayment(e, 'ptcredit')}
                                                    />
                                                </div>
                                                <div className="col-8 d-flex flex-column">
                                                    <label htmlFor="" className="text ar-light-color">Comments</label>
                                                    <input
                                                        type="text"
                                                        className="form-control fc-xs rounded form-control-amount"
                                                        name="Comments"
                                                        id="Comments"
                                                        autoComplete='off'
                                                        value={mainPtCredit.Comments}
                                                        onChange={(e) => handleChangePatientPayment(e, 'ptcredit')}
                                                    />
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>
                            </div>
                        </div>
                        <div className="">
                            <div className="ar-row ar-toggle m-0 mb-1">
                                <div>
                                    <p className="heading ms-1 "> Due Claims</p>
                                </div>
                                {/* {mainPateintModal?.PostingStatus !== 'Posted' && !isNull(UnAppliedAAmount) ? */}
                                <div className='d-flex gap-1 align-items-center'>
                                    <p className='heading'>Auto Allocate</p>
                                    <div class="pe-0 m-0 insurance_radio_btn">
                                        <div class="form-check form-switch radio_button mh-unset m-0">
                                            <input
                                                class="form-check-input m-0"
                                                type="checkbox"
                                                id="filesView"
                                                name="filesView"
                                                autocomplete="off"
                                                checked={isAutoAllocated}
                                                onChange={handleAutoAllocate}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* : null} */}


                            </div>
                            <div className="card-body p-0 bg-light-blue hk-expand-table ad-expand-table service_line">
                                <table>
                                    <thead className='sticky-top top-2'>
                                        <tr>
                                            <th style={{ width: '91px' }}>
                                                <div className="head-flex heading">
                                                    <span>Claim ID</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="head-flex haeding ">
                                                    <span>Line ID</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="head-flex haeding ">
                                                    <span>DOS</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="head-flex haeding ">
                                                    <span>CPT</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="head-flex haeding ">
                                                    <span>Billed Amt</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="head-flex haeding ">
                                                    <span>Ins Paid</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="head-flex haeding ">
                                                    <span>Ins Bal</span>
                                                </div>
                                            </th>
                                            {/* <th>
                                    <div className="head-flex">
                                        <span>Amount</span>
                                    </div>
                                </th> */}
                                            <th>
                                                <div className="head-flex haeding">
                                                    <span>Pat Paid</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="head-flex haeding">
                                                    <span>Pat Bal</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="head-flex haeding ">
                                                    <span>Allocate Amt</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="head-flex haeding">
                                                    <span>Posted Date</span>
                                                </div>
                                            </th>
                                            {/* <th>
                                    <div className="head-flex">
                                        <span>Paid</span>
                                    </div>
                                </th>
                                <th>
                                    <div className="head-flex"> */}
                                            {/* {/ <i className="icon-info"></i> /}
                                        {/ <span>More Info</span> /}
                                        {/ </div> /}
                                        {/ </th> /}
                                        {/ <th>Delete Row</th> /} */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {DueClaims.map((item, index) => {
                                            return (
                                                <tr>
                                                    <td onClick={() => handleOpenClaim(item)}>{item.ClaimID}</td>
                                                    <td>{item.ServiceLineID}</td>
                                                    <td>{item.DOS}</td>
                                                    <td>{item.CPTCode}</td>
                                                    <td><AmountFormatter amount={item.BilledAmount} /></td>
                                                    <td><AmountFormatter amount={item.PaidAmount} /></td>
                                                    <td><AmountFormatter amount={item.InsuranceBalance} /></td>
                                                    <td><AmountFormatter amount={item.PatientPaid} /></td>
                                                    <td className='position-relative text'>
                                                        <div className='ar-hov' onMouseEnter={handleMouseEnter}>
                                                            <AmountFormatter amount={item.PatientBalance} />
                                                        </div>
                                                        <div className='ar-pat-bal' style={divStyle}>
                                                            <div className='d-flex align-items-center ms-1'>
                                                                <div className='square col-md-2 me-2'>
                                                                </div>
                                                                <div className=' col-md-6'>
                                                                    <p className='text xxsm_text ar-text-clr'>Copay</p>
                                                                </div>

                                                                <div className='ar-pat-box d-flex align-items-center px-1'>
                                                                    <p className='text xxsm_text text-white '> <AmountFormatter amount={item.Copay} /></p>
                                                                </div>
                                                            </div>
                                                            <div className='mt-1 d-flex align-items-center ms-1'>
                                                                <div className='square col-md-2 me-2'>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                    <p className='text xxsm_text ar-text-clr'>Deductible</p>
                                                                </div>

                                                                <div className='ar-pat-box d-flex align-items-center px-1'>
                                                                    <p className='text xxsm_text text-white'><AmountFormatter amount={item.Deductible} /></p>
                                                                </div>
                                                            </div>
                                                            <div className='mt-1 d-flex align-items-center ms-1'>
                                                                <div className='square col-md-2 me-2'>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                    <p className='text xxsm_text ar-text-clr'>Co-Insurance</p>
                                                                </div>

                                                                <div className='ar-pat-box d-flex align-items-center px-1'>
                                                                    <p className='text xxsm_text text-white'><AmountFormatter amount={item.CoInsurance} /></p>
                                                                </div>
                                                            </div>
                                                            <div className='mt-1 d-flex align-items-center ms-1'>
                                                                <div className='square col-md-2 me-2'>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                    <p className='text xxsm_text ar-text-clr'>Other Amount</p>
                                                                </div>

                                                                <div className='px-1'>
                                                                    <p className='text xxsm_text ar-light-color'>
                                                                        <AmountFormatter amount={item.OtherAmount} />
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='hk-table-flex'>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="AllocateAmount"
                                                                id="AllocateAmount"
                                                                variant="outlined"
                                                                value={item.AllocateAmount}
                                                                // onChange={(e) => handleServiceLineChange(data.RowID, e)}
                                                                onChange={(e) => handleDueClaimChange(e, index)}
                                                                onBlur={(e) => calculateCollectedAmount(e)}
                                                                readOnly={item.IsReadOnly}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>{item.PostedDate}</td>
                                                </tr>

                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {/* <div className="mt-2 px-2">
                        {!isAmountNull(mainPateintModal.TransferToAdvance) ?
                            <div className="orange-alert mb-15">
                                <div className='ar-alert d-flex m-0 me-1 py-1'>
                                    <i className='fs-13 icon-alert lh-16 m-0'></i>
                                    <p className="text ms-1 fs-11">Amount transferred to Advance Payment: <span className='font-sb'>{`${'$' + mainPateintModal.TransferToAdvance}`}</span> </p>
                                </div>
                            </div> :
                            !isAmountNull(mainPateintModal.UseFromAdvace) ?
                                <div className="orange-alert mb-15">
                                    <div className='ar-alert d-flex m-0 me-1 py-1'>
                                        <i className='fs-13 icon-alert lh-16 m-0'></i>
                                        <p className="text ms-1 fs-11">Payment was made from Advance Payment</p>

                                    </div>
                                </div>
                                : null}
                        {paymentMethod === 'Credit' && GatewayFeesOnPatient ?
                            <div className='ar-alert m-0 d-flex align-items-center'>
                                <i className='icon-alert'></i>
                                <div>
                                    <p className='text ms-1 fst-italic'>
                                        A processing fee may apply to payments made through the payment gateway in accordance with practice policy, when applicable.
                                    </p>
                                </div>
                            </div> : null}
                        {isCreditPaymentSucess ?
                            <div className="orange-alert mb-15">
                                <div className='ar-alert d-flex m-0 me-1 py-1'>
                                    <i className='fs-13 icon-alert lh-16 m-0'></i>
                                    <p className="text ms-1 fs-11">Payment Successful. <span className='font-sb cursor-pointer' onClick={ViewPatientCriditRecipt}>view receipt here </span> </p>
                                </div>
                            </div> : null
                        }
                    </div> */}
                    <div className='d-flex justify-content-between align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light gap-2 ar_footer'>
                        <div className='m-0 d-flex align-items-center'>
                            {!isAmountNull(mainPateintModal.TransferToAdvance) ?
                                <div className="orange-alert mb-15">
                                    <div className='ar-alert d-flex m-0 me-1 py-1'>
                                        <i className='fs-13 icon-alert lh-16 m-0'></i>
                                        <p className="text ms-1 fs-11">Amount transferred to Advance Payment: <span className='font-sb'>{`${'$' + mainPateintModal.TransferToAdvance}`}</span> </p>
                                    </div>
                                </div> :
                                !isAmountNull(mainPateintModal.UseFromAdvace) ?
                                    <div className="orange-alert mb-15">
                                        <div className='ar-alert d-flex m-0 me-1 py-1'>
                                            <i className='fs-13 icon-alert lh-16 m-0'></i>
                                            {/* <p className="text ms-1 fs-11">Patient has <span className='font-sb'>{`${'$' + mainPateintModal.UseFromAdvace}`}</span> as advance payment.</p> */}
                                            <p className="text ms-1 fs-11">Payment was made from Advance Payment</p>

                                        </div>
                                    </div>
                                    : null}
                            {paymentMethod === 'Credit' && GatewayFeesOnPatient ?
                                <div className='ar-alert m-0 d-flex gap-1 checkbox-multiline-alignment'>
                                    <i className='icon-alert'></i>
                                    <p className='text fst-italic'>
                                        A processing fee may apply to payments made through the payment gateway in accordance with practice policy, when applicable.
                                    </p>
                                </div> : null}
                            {isCreditPaymentSucess ?
                                <div className="orange-alert mb-15">
                                    <div className='ar-alert d-flex m-0 me-1 py-1'>
                                        <i className='fs-13 icon-alert lh-16 m-0'></i>
                                        <p className="text ms-1 fs-11">Payment Successful. <span className='font-sb cursor-pointer' onClick={ViewPatientCriditRecipt}>view receipt here </span> </p>
                                    </div>
                                </div> : null
                            }
                        </div>
                        {isCreditPaymentSucess ? null :
                            <div className='d-flex justify-content-center align-items-center gap-2'>
                                <button className="btn btn-outline px-10 h-100 dark-clr" onClick={OnClosePayment}>Cancel</button>
                                <button className={IsEditAllowed ? 'btn btn-validate px-10 h-100 d-flex justify-content-center align-items-center gap-1' : 'btn btn-validate px-10 h-100 disabled'}
                                    onClick={() => handleSavePtPayment()}>Save
                                    {/* <i className='icon-Symbol-24--25 text-white fs-12'></i> */}
                                </button>
                            </div>
                        }
                    </div>
                    {/* {isCreditPaymentSucess ? null :
                        <ModalFooter isSaved={OnClosePayment} handleSave={handleSavePtPayment} key={'PateintPayment'} Name={'PateintPayment'} UpdatedDate={''} UpdatedBy={''} ID={''} IsEditAllowed={IsEditAllowed} />
                        } */}
                </Modal.Body>

            </Modal >
        </>
    )
}

export default PatientPayments